import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

export const initGlobalAnimations = () => {
  let mm = gsap.matchMedia()

  gsap.config({
    nullTargetWarn: false,
  })

  mm.add('(prefers-reduced-motion: no-preference) and (min-width: 768px)', () => {

    const parallaxImages: NodeListOf<HTMLElement> =
      document.querySelectorAll('[data-parallax-img]')
    
    if (parallaxImages.length) {

      for (const item of parallaxImages) {
        const img = item.getElementsByTagName('img')[0];

        if(img) {

          gsap.to(img, {
            scrollTrigger: {
              trigger: item,
              scrub: 0.5,
              invalidateOnRefresh: true
            },
            y: -120,
            ease: "power1.inOut",
          });
        }
        
      }
    }

    window.addEventListener('resize', () => {
      ScrollTrigger.refresh()
    })

    const headingAnimationEls: HTMLElement[] = gsap.utils.toArray('.title')

    headingAnimationEls.forEach((el) => {

      const split = new SplitText(el, { type: 'words' })

      // wrap words with overflow-hidden
      split.words.forEach((word) => {
        const wrapper = document.createElement('span')
        wrapper.style.overflow = 'hidden'
        wrapper.style.display = 'inline-block'
        wrapper.style.verticalAlign = 'bottom'

        word.parentNode?.insertBefore(wrapper, word)
        wrapper.appendChild(word)
      })

      // animate words from btotom
      gsap.from(split.words, {
        opacity: 0,
        yPercent: 120,
        duration: 1,
        ease: 'power4.inOut',
        stagger: {
          each: 0.05,
          from: 'start',
        },
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          end: 'top 50%',
          //markers: true, // remove later
        },
      })
    })
    

  })
}

